import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { User } from "../models/user";

const canActivate: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const user: User = JSON.parse(sessionStorage.getItem('currentUser'));
  const router = inject(Router)
  if (user.passwordTemporary) return router.createUrlTree(['page/new-password']);
  return true;
};

export const NewPasswordGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => canActivate(route, state);
